module.exports = __webpack_public_path__ + "img/filter-icon.b9c13503.svg";